// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LDPa","placeholdersHeader":"styles_placeholdersHeader__1kfcq","editorStyle":"styles_editorStyle__jct2h","placeholdersBox":"styles_placeholdersBox__3yeEt"};